<template>
  <div class="Index">
    <!-- <div class="title">
      <a-icon type="sound" class="title_icon"/>
      <span class="txt">时间是社会和信息化的基础、国家标准时间是国家战略资源、基于国家标准时间的可信时间是依法治网的基础、可信时间服务是信息化的基础服务设施。</span>
    </div>-->
    <div class="item_list">
      <!-- <div class="top_list">
        <div class="item_top">
          <div class="img_lt"></div>
          <div class="lines"></div>
          <div class="img_rt"></div>
        </div>
      </div>-->
      <div class="list_txt">
        <div>
          <div class="txt_top">时间戳第三方查验系统</div>
          <div class="txt_bot">官方查询，确保时间数据的可信</div>
        </div>
      </div>
      <div class="list_form">
        <a-form-model :model="userForm" :rules="rules" ref="ruleForm">
          <div class="radios">
            <span class="items">*</span>
            <a-radio-group v-model="form.radio" @change="onChange">
              <a-radio :value="1" style="margin-right:60px;width:180px">
                上传文件计算HASH
                <a-tooltip class="tooltip">
                  <template slot="title">请求时间凭证时上传文件，上传该文件并计算HASH</template>
                  <a-icon type="question-circle" class="question_circle"/>
                </a-tooltip>
              </a-radio>
              <a-radio :value="2">
                电子指纹(HASH值)
                <a-tooltip class="tooltip">
                  <template slot="title">
                    <p style="font-size:12px">请求时间凭证传入的电子指纹(HASH值)，填写该电子指纹(HASH值)进行效验</p>
                  </template>
                  <a-icon type="question-circle" class="question_circle"/>
                </a-tooltip>
              </a-radio>
            </a-radio-group>
          </div>
          <a-form-model-item class="form_model_item" prop="hashFile" v-show="form.radio==1">
            <a-input class="ipt rtmap" size="large" :placeholder="placeholder_txt" disabled/>
            <a-upload
              :file-list="userForm.hashFile"
              :remove="handleRemove"
              :before-upload="beforeUpload"
            >
              <a-button :disabled="userForm.hashFile.length>0" size="large" type="primary">选择文件</a-button>
            </a-upload>
          </a-form-model-item>
          <a-form-model-item class="form_model_item" prop="hash" v-show="form.radio==2">
            <a-input
              v-model="userForm.hash"
              class="ipt"
              size="large"
              placeholder="电子指纹(HASH值)"
              allow-clear
            />
          </a-form-model-item>
          <div class="radios">
            <span class="items">*</span>
            <a-radio-group v-model="form.radio2" @change="onChange2">
              <a-radio :value="1" style="margin-right:60px;width:180px">
                上传.tsr凭证
                <a-tooltip class="tooltip">
                  <template slot="title">请求时间凭证接口返回的结果生产tsr凭证文件</template>
                  <a-icon type="question-circle" class="question_circle"/>
                </a-tooltip>
              </a-radio>
              <a-radio :value="2">
                时间戳文件编号
                <a-tooltip class="tooltip">
                  <template slot="title">
                    <p style="font-size:12px">请求时间凭证传入的时间戳文件编号，填写该时间戳文件编号进行效验</p>
                  </template>
                  <a-icon type="question-circle" class="question_circle"/>
                </a-tooltip>
              </a-radio>
            </a-radio-group>
          </div>

          <a-form-model-item class="form_model_item" prop="hashFile" v-show="form.radio2==1">
            <a-input class="ipt rtmap" size="large" :placeholder="placeholder_tsr" disabled/>
            <a-upload
              :file-list="userForm.tsrFile"
              :remove="handleRemove2"
              :before-upload="beforeUpload2"
              accept=".tsr"
            >
              <a-button :disabled="userForm.tsrFile.length>0" size="large" type="primary">选择文件</a-button>
            </a-upload>
          </a-form-model-item>
          <a-form-model-item v-show="form.radio2==2">
            <a-input v-model="userForm.oid" size="large" placeholder="请输入时间戳文件编号" allow-clear/>
          </a-form-model-item>
          <a-form-model-item class="inputItem flex_list" prop="code" label="安全验证:">
            <a-input
              class="node"
              size="large"
              placeholder="请输入验证码"
              v-model="userForm.code"
              :maxLength="4"
              allow-clear
            ></a-input>
            <div class="codeBox">
              <img alt="验证码" :src="codes.src" @click="refreshCode">
            </div>
          </a-form-model-item>
          <a-form-model-item style="margin:50px 0;">
            <a-button
              type="primary"
              size="large"
              block
              @click="verification_list"
              :loading="loading"
            >立即验证</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { getData, getDatas, loginData, postData } from "@/request/all";
export default {
  name: "Index",
  data() {
    return {
      loading: false,
      placeholder_txt: "选择文件",
      placeholder_tsr: "选择文件",
      rules: {
        oid: [
          { required: true, message: "请输入时间戳系列号", trigger: "blur" }
        ],
        // hash: [{ required: true, message: "请输入事物HASH", trigger: "blur" }],
        code: [
          { required: true, message: "请输验证码", trigger: "blur" },
          { min: 4, max: 4, message: "请输入4位数验证码", trigger: "blur" }
        ]
      },
      form: {
        radio: 1,
        radio2: 1
      },
      userForm: {
        oid: "",
        hash: "",
        hashFile: [],
        code: "",
        randomStr: "",
        tsrFile: []
      },
      code: {
        src: "",
        value: "",
        len: 4,
        type: "image"
      },
      codes: {
        src: ""
      },
      codeUrl: "/code/?randomStr="
    };
  },
  created() {
    this.refreshCode();
  },
  methods: {
    handleRemove(file) {
      const index = this.userForm.hashFile.indexOf(file);
      const newFileList = this.userForm.hashFile.slice();
      newFileList.splice(index, 1);
      this.userForm.hashFile = newFileList;
      if (this.userForm.hashFile.length < 1) {
        this.placeholder_txt = "选择文件";
      }
    },

    beforeUpload(file) {
      console.log(file, 333);
      let items = file.size / 1024 < 20480;
      if (!items) {
        this.$message.warning("上传文件大小不能超过 20MB!");
        return false;
      }
      this.userForm.hashFile = [...this.userForm.hashFile, file];
      if (this.userForm.hashFile.length > 0) {
        this.placeholder_txt = "";
      }
      return false;
    },
    handleRemove2(file) {
      const index = this.userForm.tsrFile.indexOf(file);
      const newFileList = this.userForm.tsrFile.slice();
      newFileList.splice(index, 1);
      this.userForm.tsrFile = newFileList;
      if (this.userForm.tsrFile.length < 1) {
        this.placeholder_tsr = "选择文件";
      }
    },
    beforeUpload2(file) {
      let items = file.size / 1024 < 20480;
      if (!items) {
        this.$message.warning("上传文件大小不能超过 20MB!");
        return false;
      }
      this.userForm.tsrFile = [...this.userForm.tsrFile, file];
      // console.log(this.userForm.tsrFile, 5555);
      if (this.userForm.tsrFile.length > 0) {
        this.placeholder_tsr = "";
      }
      return false;
    },
    // 验证码
    refreshCode() {
      let that = this;
      that.userForm.code = "";
      const len2 = that.code.len;
      const random = Math.ceil(Math.random() * 100000000000000)
        .toString()
        .substr(0, typeof len2 === "number" ? len2 : 4);
      const random2 = random + Date.now();
      that.userForm.randomStr = random2;
      that.codes.src = that.codeUrl + that.userForm.randomStr;
    },
    // 立即验证
    verification_list() {
      let that = this;
      if (that.userForm.hash == "" && that.userForm.hashFile.length < 1) {
        this.$message.warning(
          "必填信息不能为空！请上传文件计算HASH或输入电子指纹(HASH值)"
        );
      } else if (that.userForm.oid == "" && that.userForm.tsrFile.length < 1) {
        this.$message.warning("平台序列号或上传.tsr凭证任选一个填写！");
      } else {
        that.$refs.ruleForm.validate(valid => {
          if (valid) {
            let formdata = new FormData();
            formdata.append("oid", that.userForm.oid);
            formdata.append("hash", that.userForm.hash);
            // formdata.append("randomStr", that.userForm.randomStr);
            // formdata.append("code", that.userForm.code);
            that.userForm.hashFile.forEach(file => {
              formdata.append("hashFile", file);
            });
            that.userForm.tsrFile.forEach(file => {
              formdata.append("tsrFile", file);
            });
            that.loading = true;
            postData(
              "/timeStamp/check?" +
                "code=" +
                that.userForm.code +
                "&" +
                "randomStr=" +
                that.userForm.randomStr,
              "post",
              formdata
            )
              .then(response => {
                if (response.data.code == 0) {
                  sessionStorage.setItem(
                    "list_data",
                    JSON.stringify(response.data.data)
                  );

                  that.loading = false;
                  that.$router.push("/success");
                } else {
                  if (response.data.msg == "图片验证码错误") {
                    that.userForm.code = "";
                    that.$message.warning(response.data.msg);
                  } else {
                    that.userForm = {
                      oid: "",
                      hash: "",
                      hashFile: [],
                      code: "",
                      randomStr: "",
                      tsrFile: []
                    };
                    that.$router.push("/ValidationFailed");
                  }

                  that.loading = false;
                  that.refreshCode();
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    onChange(val) {
      this.form.radio = val.target.value;
      if (this.form.radio == 1) {
        this.placeholder_txt = "选择文件";
      }
      if (val.target.value == 1) {
        this.userForm.hash = "";
      } else if (this.userForm.hashFile.length > 0) {
        const newFileList = this.userForm.hashFile.slice();
        newFileList.splice(0, 1);
        this.userForm.hashFile = newFileList;
      }
    },
    onChange2(val) {
      this.form.radio2 = val.target.value;
      if (this.form.radio2 == 1) {
        this.placeholder_tsr = "选择文件";
      }
      if (val.target.value == 2) {
        this.userForm.oid = "";
      } else if (this.userForm.tsrFile.length > 0) {
        const newFileList = this.userForm.tsrFile.slice();
        newFileList.splice(0, 1);
        this.userForm.tsrFile = newFileList;
      }
    }
  }
};
</script>

<style lang='less'>
.Index {
  .items {
    color: red;
    display: inline-block;
    height: 18px;
    font-size: 18px;
    margin-right: 3px;
  }
  .flex_list .ant-form-item-children {
    display: flex;
    justify-content: space-between;
  }
  .node {
    width: 77%;
    margin-right: 15px;
  }
  .codeBox {
    width: 23%;
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;

      vertical-align: top;
    }
  }
  .title {
    height: 45px;
    line-height: 45px;
    padding-left: 5px;
    border: 1px solid #959fa8;
    background: #d7dce2;
    color: #417b9d;
  }
  .item_list {
    .form_model_item {
      .ipt {
        // margin-right: 10px;
      }
      .ant-input[disabled] {
        background-color: #ffff !important;
      }
      .rtmap {
        margin-right: 10px;
      }
      .ant-form-item-children {
        display: flex;
        align-items: center;
      }
      .ant-upload-list-text {
        position: absolute;
        top: 1px;
        left: 1px;
        width: 80%;
      }
    }
    .item_top {
      height: 170px;
      display: flex;
      justify-content: space-between;
      width: 710px;
      margin: 40px auto 10px auto;
      .lines {
        width: 1px;
        background: #000000;
      }

      .img_lt {
        margin-left: 164px;
        width: 170px;
        height: 100%;
      }
      .img_rt {
        width: 350px;
        height: 100%;
      }
      .img_lt {
        background: url(../../assets/img/ltimg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .img_rt {
        background: url(../../assets/img/rtimg2.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    .list_txt {
      width: 620px;
      margin: 0 auto;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 3px solid #008de7;
      color: #007cc3;
      font-size: 16px;
      .txt_top,
      .txt_bot {
        text-align: center;
      }
      .txt_bot {
        color: #666;
        font-size: 16px;
        margin-top: 15px;
      }
    }
    .list_form {
      width: 620px;
      margin: 0 auto;
      margin-top: 20px;
      .radios {
        margin-bottom: 7px;
        display: flex;
        align-items: center;
      }
      .ant-radio-wrapper-checked {
        color: #409eff;
      }

      .question_circle {
        margin-left: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue